export default __webpack_public_path__ + "static/media/1980.f6efebdf.png";